module.exports = __webpack_public_path__ + "static/img/hysteroscope-2.e8c4344.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/hysteroscopepic/hysteroscope-2.jpg
// module id = 33Jm
// module chunks = 52